import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, timeout } from 'rxjs';
import { environment } from '../../environments/environment';

export interface LotCartouche {
  id: number;
  nom: string;
  date_reception: string;
  nombre_cartouches: number;
}

export interface LotCartouchePayload {
  nom: string;
  date_reception?: string;
  nombre_cartouches?: number;
}

export interface LotCartoucheLinkStatus {
  lot_id: number;
  linked: boolean;
  linked_capteurs_count: number;
}

@Injectable({ providedIn: 'root' })
export class LotsCartouchesService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/lots-cartouches`;
  private readonly requestTimeoutMs = 30000;

  constructor(private readonly http: HttpClient) {}

  list(): Observable<LotCartouche[]> {
    return this.http
      .get<{ items?: LotCartouche[] } | LotCartouche[]>(this.baseUrl)
      .pipe(
        timeout(this.requestTimeoutMs),
        map((response) => {
          if (Array.isArray(response)) {
            return response;
          }
          return Array.isArray(response?.items) ? response.items : [];
        })
      );
  }

  getById(id: number): Observable<LotCartouche> {
    return this.http
      .get<LotCartouche>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }

  create(payload: LotCartouchePayload): Observable<LotCartouche> {
    return this.http
      .post<LotCartouche>(this.baseUrl, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  update(id: number, payload: LotCartouchePayload): Observable<LotCartouche> {
    return this.http
      .put<LotCartouche>(`${this.baseUrl}/${id}`, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  delete(id: number): Observable<{ deleted: boolean; id: number }> {
    return this.http
      .delete<{ deleted: boolean; id: number }>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }

  getLinkedToCapteur(id: number): Observable<LotCartoucheLinkStatus> {
    return this.http
      .get<LotCartoucheLinkStatus>(`${this.baseUrl}/${id}/linked-to-capteur`)
      .pipe(timeout(this.requestTimeoutMs));
  }
}
